import {CdMdsAnswerOption} from '../../../interfaces/care/cd-rai/cd-mds-answer-option';


export class CdMdsAnswerOptionFactory {

  /**
   *
   * @param caMdsAnswerOption
   */
  public static fromObject(caMdsAnswerOption: any): CdMdsAnswerOption {
    return {
      id: caMdsAnswerOption.id,
      cdMdsQuestionId: caMdsAnswerOption.c_mds_question_id,
      value: caMdsAnswerOption.value,
      text: caMdsAnswerOption.text
    };
  }


  /**
   *
   * @param caMdsAnswerOptions
   */
  public static fromArray(caMdsAnswerOptions: any[]): CdMdsAnswerOption[] {
    return caMdsAnswerOptions.map(_caMdsAnswerOption => CdMdsAnswerOptionFactory.fromObject(_caMdsAnswerOption));
  }

}
